"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = require("@/utils/index");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    dialogStatus: {
      type: String,
      default: 'create'
    },
    refreshData: {
      type: Function,
      default: function _default() {}
    },
    form: {
      type: Object,
      default: function _default() {
        return {
          userPk: '',
          userName: '',
          loginCode: '',
          userMobile: '',
          remark: ''
        };
      }
    }
  },
  data: function data() {
    var _this = this;
    var validateUserName = function validateUserName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('interfaceUser.error.userName')));
      } else if (_this.errorKeys.indexOf('userName') >= 0) {
        callback(new Error(_this.errorInfo['userName']));
        _this.resetError('userName');
      } else {
        callback();
      }
    };
    var validateLoginCode = function validateLoginCode(rule, value, callback) {
      if ((0, _validate.validRule3)(value)) {
        callback(new Error(_this.$t('interfaceUser.error.loginCode')));
      } else if (_this.errorKeys.indexOf('loginCode') >= 0) {
        callback(new Error(_this.errorInfo['loginCode']));
        _this.resetError('loginCode');
      } else {
        callback();
      }
    };
    var validateUserMobile = function validateUserMobile(rule, value, callback) {
      if (!value) {
        callback();
      }
      if ((0, _validate.validPhone)(value)) {
        callback(new Error(_this.$t('interfaceUser.error.userMobile')));
      } else if (_this.errorKeys.indexOf('userMobile') >= 0) {
        callback(new Error(_this.errorInfo['userMobile']));
        _this.resetError('userMobile');
      } else {
        callback();
      }
    };
    var validateRemark = function validateRemark(rule, value, callback) {
      if (!value) {
        callback();
      }
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('interfaceUser.error.remark')));
      } else if (_this.errorKeys.indexOf('remark') >= 0) {
        callback(new Error(_this.errorInfo['remark']));
        _this.resetError('remark');
      } else {
        callback();
      }
    };
    return {
      isVisible: false,
      formLabelWidth: '120px',
      formValue: {
        userPk: '',
        userName: '',
        loginCode: '',
        userMobile: '',
        remark: ''
      },
      rules: {
        userName: [{
          required: true,
          trigger: ['change'],
          validator: validateUserName
        }],
        loginCode: [{
          required: true,
          trigger: ['change'],
          validator: validateLoginCode
        }],
        userMobile: [{
          required: false,
          trigger: ['change'],
          validator: validateUserMobile
        }],
        remark: [{
          required: false,
          trigger: ['change'],
          validator: validateRemark
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  watch: {
    isShow: function isShow(val) {
      var _this2 = this;
      this.isVisible = val;
      if (val) {
        this.$nextTick(function () {
          _this2.$refs['dataForm'].clearValidate();
        });
      }
    },
    form: function form(val) {
      this.formValue = (0, _objectSpread2.default)({}, this.form);
    }
  },
  mounted: function mounted() {},
  methods: {
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    clickCloseBtn: function clickCloseBtn(done) {
      var _this3 = this;
      var a = (0, _index.compareObject)(this.formValue, this.form);
      if (a) {
        this.$emit('dialogHidden');
      } else {
        this.$confirm(this.$t('common.confirm11')).then(function (_) {
          _this3.$emit('dialogHidden');
          // done()
        }).catch(function (_) {});
      }
    },
    clickCancel: function clickCancel() {
      this.$emit('dialogHidden');
    },
    clickSave: function clickSave() {
      var _this4 = this;
      this.$refs['dataForm'].clearValidate();
      console.log('=======clickSave====');
      this.$refs.dataForm.validate(function (valid) {
        console.log('====1111===clickSave====', valid);
        if (!valid) return;
        var param = {
          userPk: _this4.formValue.userPk,
          userName: _this4.formValue.userName,
          loginCode: _this4.formValue.loginCode,
          userMobile: _this4.formValue.userMobile,
          remark: _this4.formValue.remark
        };
        _this4.$api.interfaceuser.saveInterfaceUser(param).then(function (res) {
          _this4.$emit('dialogHidden');
          _this4.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this4.resetError();
            err.errorInfos.forEach(function (item) {
              _this4.errorKeys.push(item.key);
              _this4.errorInfo[item.key] = item.errMsg;
            });
            _this4.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          // this.$message.error('保存失败')
        });
      });
    }
  }
};